import { type MutableRefObject, useCallback, useRef, useState } from 'react';
import type { StanFloatingMenuHandle } from '@/components/core-components/StanDropdown/FloatingMenu/StanFloatingMenu';

export type FloatingTriggerProps = {
    disabled: boolean;
    'aria-haspopup': 'dialog';
    'aria-expanded': boolean;
};

export interface FloatingFilterMenuHook {
    menuRef: MutableRefObject<StanFloatingMenuHandle | null>;
    triggerProps: FloatingTriggerProps;
    closeMenu: () => void;
    isOpen: boolean;
    handleOpenChange: (isOpen: boolean) => void;
}

export const useFloatingFilterMenu = (disabled = false): FloatingFilterMenuHook => {
    const menuRef = useRef<StanFloatingMenuHandle | null>(null);
    const [isOpen, setIsOpen] = useState(false);

    const closeMenu = useCallback(() => {
        menuRef.current?.setMenu(false);
        setIsOpen(false);
    }, []);

    const triggerProps: FloatingTriggerProps = {
        disabled,
        'aria-haspopup': 'dialog',
        'aria-expanded': isOpen,
    };

    const handleOpenChange = (open: boolean) => {
        setIsOpen(open);
    };

    return {
        menuRef,
        triggerProps,
        closeMenu,
        isOpen,
        handleOpenChange,
    };
};
